<script>
import moment from "@wielink-application/shared/js/mixins/moment";
import Modal from "@/pages/components/modal.vue";
import InfoModal from "@/pages/appointments/partials/info-modal.vue";

export default {
  components: {Modal, InfoModal},
  mixins: [moment],
  data() {
    return {
      show: {},
      appointments: []
    }
  },

  methods: {
    getAppointments() {
      $.ajax({
        url: route('api.v1.appointments.today'),
        success: (response) => {
          this.appointments = response.data;
        }
      })
    },

    openModal(appointment) {
      this.show = appointment;
      this.$refs.modal.open();
    }
  },

  mounted() {
    this.getAppointments();
  }
}
</script>

<template>
  <div class="table-responsive">
    <table class="table table-striped table-sm m-0">
      <thead>
        <tr>
          <th>Afspraak</th>
          <th>Tijd</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr valign="middle" v-for="appointment in appointments" :key="appointment.id">
          <td>{{ appointment.name }}</td>
          <td style="white-space: nowrap">{{ moment(appointment.start_date).format('HH:mm') }} - {{ moment(appointment.end_date).format('HH:mm') }}</td>
          <td style="white-space: nowrap" class="text-end">
            <button class="btn btn-sm btn-primary" @click.prevent="openModal(appointment)">Meer info</button>
          </td>
        </tr>

        <tr v-if="appointments.length < 0">
          <td colspan="4">Er zijn geen afspraken ingepland</td>
        </tr>
      </tbody>
    </table>
  </div>

  <InfoModal :appointment="show" ref="modal"/>
</template>